import macarronada from "../assets/images/recipes/macarronada.png";
import saguadin from "../assets/images/recipes/saguadin.png";
import torta from "../assets/images/recipes/torta.png";

const recipes = [
  {
    id: 1,
    name: "Macarronada vegetariana",
    description: "30 min | 2 pessoas",
    image: macarronada,
    categoryId: 1,
  },
  {
    id: 2,
    name: "Macarronada",
    description: "2 horas | 1 pessoa",
    image: saguadin,
    categoryId: 2,
  },
  {
    id: 3,
    name: "Macarronada",
    description: "90 min | 3 pessoas",
    image: torta,
    categoryId: 3,
  },
];

export default recipes;
